/**
 * @generated SignedSource<<3d2b43e081497b78179f5daf47f3d05a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VaultManagementGroupSelect_vaultManager$data = {
  readonly id: string;
  readonly vaultManagementGroups: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"VaultManagementGroupLabel_vaultManagementGroup">;
      } | null;
    }>;
  };
  readonly " $fragmentType": "VaultManagementGroupSelect_vaultManager";
};
export type VaultManagementGroupSelect_vaultManager$key = {
  readonly " $data"?: VaultManagementGroupSelect_vaultManager$data;
  readonly " $fragmentSpreads": FragmentRefs<"VaultManagementGroupSelect_vaultManager">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VaultManagementGroupSelect_vaultManager",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "managedByMyself",
          "value": true
        }
      ],
      "concreteType": "VaultManagementGroupConnection",
      "kind": "LinkedField",
      "name": "vaultManagementGroups",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "VaultManagementGroupEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "VaultManagementGroup",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "VaultManagementGroupLabel_vaultManagementGroup"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "vaultManagementGroups(managedByMyself:true)"
    }
  ],
  "type": "VaultManager",
  "abstractKey": null
};
})();

(node as any).hash = "1faccfa11ac3211bc3745737a7ce5f83";

export default node;
